import { useNavigate } from "react-router-dom";
import {
  mockQuickActions,
  type QuickActionItem,
} from "../mockdata/dashboardMockData";
import "./styles/AlternativStyle.scss";

interface QuickActionsGridProps {
  title?: string;
  actions?: QuickActionItem[];
  variant?: "dashboard" | "menu";
}

function QuickActionsGrid({
  actions = mockQuickActions,
  variant = "dashboard",
}: QuickActionsGridProps) {
  const navigate = useNavigate();

  const handleCardClick = (route: string) => navigate(route);

  return (
    <div className="gx-quick-actions-grid">
      {actions.map((action) => (
        <button
          key={action.id}
          type="button"
          className={`gx-quick-action-card gx-quick-action-card--${variant}`}
          onClick={() => handleCardClick(action.route)}
        >
          <img
            className="gx-quick-action-icon"
            src={action.icon}
            alt={action.label}
          />
          <span className="gx-p12-sb gx-quick-action-label">
            {action.label}
          </span>
        </button>
      ))}
    </div>
  );
}

export default QuickActionsGrid;
